import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { api } from '../api/client.js';

const initialState = {
  subscription: null,
  loading: false,
  error: null,
  isProPlan: false,
};

export const useSubscriptionStore = create(
  subscribeWithSelector(
    devtools((set, get) => ({
      ...initialState,
      setLoading: (loading) => set({ loading }),
      setError: (error) => set({ error }),
      setSubscription: (subscription) => set({
        subscription,
        isProPlan:
          !!subscription &&
          (subscription.status === 'active' || subscription.status === 'trialing') &&
          !!subscription.plan,
      }),
      fetchSubscription: async () => {
        set({ loading: true, error: null });
        try {
          const subscriptionData = await api.getCurrentSubscription();
          get().setSubscription(subscriptionData);
        } catch (error) {
          console.error('SubscriptionStore: Failed to fetch subscription', error);
          set({
            subscription: null,
            isProPlan: false,
            error: error?.message || 'Failed to load subscription data',
          });
        } finally {
          set({ loading: false });
        }
      },
      openCustomerPortal: async () => {
        try {
          set({ loading: true, error: null });
          const returnUrl = window.location.href;
          const { url } = await api.createPortalSession(returnUrl);
          window.location.href = url;
          return true;
        } catch (error) {
          console.error('SubscriptionStore: Failed to open customer portal', error);
          set({ error: error?.message || 'Failed to open customer portal' });
          return false;
        } finally {
          set({ loading: false });
        }
      },
      resetSubscription: () => set(initialState),
    }), { name: 'SubscriptionStore' })
  )
);

export const selectSubscriptionState = (state) => ({
  subscription: state.subscription,
  loading: state.loading,
  error: state.error,
  isProPlan: state.isProPlan,
});

